import { AppSettings } from "./interfaces/general/app-settings";

// will be replaced in azure devops release pipe line
const appSettings : AppSettings = {
    apiPath: "#{apiPath}#"
}

export default appSettings;